/* Nordestic Startseite: Schienen (Pfeile), Filter der Kundenfotos, Holzfarben, Wunschhöhe, Versprechen, Umschalter Tag/Abend und Auf/Zu. */
(function () {
  function init(root) {
    if (!root || root.__nh2) return; root.__nh2 = true;
    var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

    // Schienen: Pfeile blättern eine Ansicht weiter und werden am Rand deaktiviert
    $$('[data-nh2-rail]').forEach(function (rail) {
      var track = rail.querySelector('.nh2-track'), btns = $$('.nh2-arrows button', rail);
      if (!track) return;
      var upd = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        btns.forEach(function (b) { b.disabled = b.dataset.dir < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max; });
      };
      btns.forEach(function (b) {
        b.addEventListener('click', function () { track.scrollBy({ left: Number(b.dataset.dir) * track.clientWidth * 0.82, behavior: 'smooth' }); });
      });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      window.addEventListener('resize', upd);
      upd(); rail.__upd = upd;
    });

    // Kundenfotos filtern
    $$('.nh2-chips button').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.dataset.f, rail = chip.closest('[data-nh2-rail]');
        $$('.nh2-chips button', rail).forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        $$('.nh2-rv', rail).forEach(function (card) { card.hidden = f !== 'all' && card.dataset.c !== f && card.dataset.c !== 'all'; });
        var track = rail.querySelector('.nh2-track'); if (track) track.scrollLeft = 0;
        if (rail.__upd) rail.__upd();
      });
    });

    // Holzfarbe am Couchtisch umschalten
    $$('.nh2-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var card = sw.closest('.nh2-card'); if (!card) return;
        $$('.nh2-swatch', card).forEach(function (o) { o.setAttribute('aria-pressed', o === sw ? 'true' : 'false'); });
        var img = card.querySelector('.nh2-card-media img.main'), name = card.querySelector('.nh2-swatch-name');
        if (img && sw.dataset.src) { img.removeAttribute('srcset'); img.src = sw.dataset.src; }
        var alt = card.querySelector('.nh2-card-media img.alt'); if (alt) alt.style.display = 'none';
        if (name) name.textContent = sw.dataset.name || '';
      });
    });


    // Wunschhöhe: Schieberegler 30–50 cm, die Zeichnung passt sich an
    $$('[data-nh2-height]').forEach(function (box) {
      var K = 2.4, FLOOR = 200, input = box.querySelector('input[type=range]');
      var legs = $$('[data-leg]', box), dim = box.querySelector('[data-dim]'), dimTop = box.querySelector('[data-dim-top]'), txt = box.querySelector('[data-dim-txt]');
      var outH = box.querySelector('[data-out-h]'), out = box.querySelector('[data-out]'), slab = box.querySelector('.l-top');
      var set = function (h) {
        var top = FLOOR - h * K;
        if (slab) slab.setAttribute('y', top);
        legs.forEach(function (l) { l.setAttribute('y', top + 9); l.setAttribute('height', Math.max(0, FLOOR - top - 9)); });
        if (dim) dim.setAttribute('y1', top);
        if (dimTop) dimTop.setAttribute('d', 'M382 ' + top + 'h12');
        if (txt) { txt.setAttribute('y', (top + FLOOR) / 2 + 5); txt.textContent = h + ' cm'; }
        if (outH) outH.textContent = h + ' cm';
        if (out) out.textContent = 'Passt zu Sofas mit ' + h + ' bis ' + (h + 5) + ' cm Sitzhöhe.';
        if (input) { input.setAttribute('aria-valuetext', h + ' Zentimeter'); input.style.setProperty('--p', ((h - 30) / 20 * 100) + '%'); }
      };
      if (input) input.addEventListener('input', function () { set(Number(input.value)); });
      set(input ? Number(input.value) : 40);
    });

    // Versprechen: das Bild links folgt der Zeile unter der Maus bzw. dem Fokus
    $$('[data-nh2-prom]').forEach(function (box) {
      var imgs = $$('.nh2-prom-fig img', box), rows = $$('.nh2-prom-list li', box);
      var on = function (i) {
        imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
        rows.forEach(function (r, k) { r.classList.toggle('is-on', k === i); });
      };
      rows.forEach(function (r, i) { r.addEventListener('mouseenter', function () { on(i); }); r.addEventListener('focusin', function () { on(i); }); });
    });

    // Umschalter (Tag/Abend, Auf/Zu)
    $$('[data-nh2-toggle]').forEach(function (box) {
      $$('.nh2-pill button', box).forEach(function (b) {
        b.addEventListener('click', function () {
          box.dataset.mode = b.dataset.mode;
          $$('.nh2-pill button', box).forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        });
      });
    });
  }
  function start() { Array.prototype.forEach.call(document.querySelectorAll('.nh2[data-nordestic-home]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
